import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal, List } from "antd";

import { i18, trb } from "@utilities";
import { AuthActions, KYCActions, StepperFormActions, selectCheckScaAuthorizations } from "@redux";
import { routerPath } from "@config";
import { ContentLoader } from "..";

export const CompanyModal = ({ onCancel }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const availableCompanies = useSelector(selectCheckScaAuthorizations);
  const [isLoading, setIsLoading] = useState(false);

  const handleCompanySelect = async company => {
    try {
      setIsLoading(true);
      await dispatch(AuthActions.selectIdentification(company));
      await dispatch(KYCActions.startKYC());
      const { payload } = await dispatch(StepperFormActions.getFormDraft());
      history.push(`${routerPath.newKycSme.basePath}/${payload.data.currentStep + 1 || 1}`);
    } catch (e) {
      onCancel();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      footer={null}
      title={trb(i18.ModalTitles.ChooseCompany)}
      visible
      onCancel={onCancel}
      maskClosable={false}
    >
      {isLoading ? (
        <ContentLoader />
      ) : (
        <List
          size="large"
          bordered
          dataSource={availableCompanies}
          renderItem={item => (
            <List.Item style={{ cursor: "pointer" }} onClick={() => handleCompanySelect(item)}>
              {item.companyName}: {item.companyCode}
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};
